/**
 * @desc 查询时效设置
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.SiteEfficiencyMasterResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/findById`, {
      method: "GET",

      ...options,
    }),
  );
}
